<template>
  <div class="container mx-auto p-0 lg:px-12 laptop:px-24 selector-container">
    <div class="border border-darkgray flex flex-col md:flex-row h-full">
      <!-- col 1 -->
      <div class="w-full sm:h-full selector-viewer3d-container">
        <iframe 
                allow="xr-spatial-tracking *;fullscreen *; web-share *" allowfullscreen allowtransparency="true" 
                style="width:100%; height:100%; border: 0"
                alt="Showcase of 3D models from different industries"
                :src=" localizedModels[selectedId].src" />
      </div>

      <!-- col 2 -->
      <div class="bg-darkgray text-white h-full selector-list-container">
        <div class="flex-grow w-full px-4 py-4 h-full overflow-y-auto flex flex-col gap-2">
          <div
            v-for="(model, id) of localizedModels"
            :key="id" class="relative"
            @click="selectedId = id"
          >
            <div class="flex flex-row cursor-pointer" :class="{'selected-decoration': id == selectedId}">
              <img :src="model.preview"
                   width="78" class="rounded" style="height:78px; min-width: 78px;">
              <div class="flex flex-col px-4 flex-grow justify-center">
                <div class="text-xs font-light">{{ $t(model.industry).toString() }}</div>
                <div class="text-sm">{{ $t(model.name).toString() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

interface ShowcaseModel {
  industry: string;
  name: string;
  src: string;
  preview: string;
}

const { locale } = useI18n()

const props = defineProps<{
  compact?: boolean
  models?: ShowcaseModel[]
}>()

const defaultModels: ShowcaseModel[] = [
  {
    industry: 'showcase-selector.polyurethaneBelt.industry',
    name: 'showcase-selector.polyurethaneBelt.name',
    src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/271b8584-1272-53b4-9ba7-61c2619bf01b/default/795c54ae-79c7-5c38-b4c7-35daae52375d/index.html',
    preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/271b8584-1272-53b4-9ba7-61c2619bf01b/default/795c54ae-79c7-5c38-b4c7-35daae52375d/export/preview.jpg'
  },
  {
    industry: 'showcase-selector.wineBottle.industry',
    name: 'showcase-selector.wineBottle.name',
    src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/Zimor%204/default/default/index.html',
    preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/Zimor%204/default/default/export/preview.jpg'
  }
]

const localizedModels = computed( () => {
  const tmpModels:ShowcaseModel[] = props.models && props.models.length ? props.models : defaultModels
  return tmpModels.map(model  => ({
    ...model,
    src: model.src + '?language=' + locale.value
  }))
})

const selectedId = ref(0)
</script>

<style scoped>
.selected-decoration::before {
    content: '';
    position:absolute;
    top: 0;
    bottom: 0;
    left:-16px;
    width: 9px;
    background-color: #0B90C4;
}

.selector-container {
  overflow:hidden;
}
@media (max-width: 767px) {
  .selector-container {
  }
  .selector-viewer3d-container {
    height: 50vh;
    max-height: 550px;
  }
  .selector-list-container {
    height: 30vh;
    max-height: 550px;
  }

}
@media (min-width: 768px) {
  .selector-container {
    height: min(850px, 75vh);
    @apply flex-1
  }
}

</style>
